import { FiltersWithQuery } from "../../components/filters";
import { Column, Row } from "../../components/grid";
import { PageLayout } from "../../components/page-layout";
import { SearchWithQueryInput } from "../../components/search-input";
import useMyTasks from "./useMyTasks";
import { tasksTableHeaders } from "../../entities/ITask";
import TaskBulkActions from "../../components/task-bulk-actions/TaskBulkActions";
import { TableWithQueryPaginationAndSort } from "../../components/table/TableWithQueryPaginationAndSort";
import { tasksTableFilters } from "../tasks/TasksScreen.types";
const MyTasksScreen = () => {
  const {
    myTasks,
    loading,
    onRowPress,
    total,
    setSelectedTasks,
    selectedTasks,
    selectedAction,
    setSelectedAction,
    reassignBulkTasks,
    reassigningTasks,
    moveBulkTasks,
    movingTasks,
  } = useMyTasks();
  return (
    <PageLayout title={`My Tasks`}>
      <div className="flex-column gap-2">
        <TaskBulkActions
          selectedTasks={selectedTasks}
          onDismiss={() => {
            setSelectedTasks([]);
          }}
          selectedAction={selectedAction}
          setSelectedAction={setSelectedAction}
          onReassign={reassignBulkTasks}
          reassigning={reassigningTasks}
          moving={movingTasks}
          onMove={moveBulkTasks}
        />
        <Row>
          <Column>
            <FiltersWithQuery
              filters={tasksTableFilters([
                "user=>id",
                "createdBy=>id",
                "user=>dealerCode",
              ])}
            />
          </Column>
          <Column>
            <div className="d-flex flex-row my-1 justify-content-end">
              <SearchWithQueryInput placeHolder="Search tasks" />
            </div>
          </Column>
        </Row>
        <Row>
          <Column>
            <TableWithQueryPaginationAndSort
              loading={loading}
              onRowPress={onRowPress}
              headers={tasksTableHeaders.filter(
                (item) =>
                  item.key !== "assignee.name" && item.key !== "createdBy.name"
              )}
              data={myTasks}
              totalItems={total}
              selection={{
                onSelectionChanged: setSelectedTasks,
                selected: selectedTasks,
              }}
            />
          </Column>
        </Row>
      </div>
    </PageLayout>
  );
};
export default MyTasksScreen;
